import React, { useState } from 'react'

import Box from '@mui/material/Box'
import DialogContent from '@mui/material/DialogContent';
import MobileStepper from '@mui/material/MobileStepper';
import Paper from '@mui/material/Paper';
import Button from '@mui/material/Button';
import KeyboardArrowLeft from '@mui/icons-material/KeyboardArrowLeft';
import KeyboardArrowRight from '@mui/icons-material/KeyboardArrowRight';

import useStyles from './styles'
import questionHandlers from './question-handlers'
import {isEmpty} from '../../../helpers/utils'

export default function StandardsQuestions({context, questions}) {
  
  const classes = useStyles()

  const {translate, quizQuestionTypes, quizAssessmentToReview: assessment} = context

  const { content = {}} = assessment
  const { sections = {}} = content

  const [activeStep, setActiveStep] = useState(0);
  const maxSteps = questions.length;

  const handleNext = () => {
    setActiveStep((prevActiveStep) => prevActiveStep + 1);
  };

  const handleBack = () => {
    setActiveStep((prevActiveStep) => prevActiveStep - 1);
  };
  
  const result = questions.map(question => sections[question.section].questions.find(q => q.id == question.id))

  const type = quizQuestionTypes.find(t => t.id == result[activeStep].type) || {}
  const Handler = questionHandlers[type.name]
  const {html} = result[activeStep].premise || {}
  const premiseHtml = isEmpty(html) ? false : html

  const defaultPremiseLabel = `${type.name}-default-premise`
  const defaultPremise = translate(defaultPremiseLabel)
  const hasDefaultPremise = defaultPremiseLabel != defaultPremise

  return (
    <Box>
          <DialogContent dividers>
            <Paper
              square
              elevation={0}
            >
             {premiseHtml && <div className={classes.premise} dangerouslySetInnerHTML={{__html: premiseHtml}} />}
             {!premiseHtml && hasDefaultPremise && <Box className={classes.premise}>{defaultPremise}</Box>}
            </Paper>
            <Box className={classes.question}>
                {Handler && <Handler context={context} question={result[activeStep]} />}
            </Box>
          </DialogContent>
            <Box >
              <MobileStepper
                variant="text"
                steps={maxSteps}
                position="static"
                activeStep={activeStep}
                className={classes.questionStepper}
                dividers
                nextButton={
                  <Button
                    size="small"
                    onClick={handleNext}
                    disabled={activeStep === maxSteps - 1}
                  >
                      {translate('next')}
                      <KeyboardArrowRight />
                  </Button>
                }
                backButton={
                  <Button size="small" onClick={handleBack} disabled={activeStep === 0}>
                      <KeyboardArrowLeft />
                      {translate('back_label')}
                  </Button>
                }
              />
            </Box>
    </Box>
  )
}